<template>
	<div>
		<swiper class="swiper_tab02" :options="swiperOption_tab02" ref="mySwiper_tab02">
			<swiper-slide :key="index" v-for="(item,index) in list">
				<component :is="item.component"></component>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	//一级导航组件 二级导航组件 -- 分类
	import categroy from '@/views/bookcity/categroy';
	import wanjie from '@/views/bookcity/wanjie';
	import soltph from '@/views/bookcity/soltPh';
	import xianmian from '@/views/bookcity/xianmian'
	import xianshiyifen from '@/views/bookcity/xianshiyifen';
	import biaoqian from '@/views/bookcity/biaoqian.vue';
	import huati from '@/views/bookcity/huati.vue';
	export default {
		props: ['swiperIndexFirstSe'],
		data() {
			const that = this
			return {
				list: [{
						component: categroy
					},
					{
						component: wanjie
					},
					{
						component: soltph
					},
					{
						component: xianmian
					},
					{
						component: xianshiyifen
					},
					{
						component: biaoqian,
					},
					{
						component: huati,
					}
				],
				mySwiper: null,
				//轮播图配置
				swiperOption_tab02: {
					spaceBetween: 0,
					centeredSlides: true,
					direction: 'horizontal',
					autoplay: false,
					loop: false,
					threshold : 50,
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					observer: false,
					observeParents: false,
					// prevButton: ".swiper-button-prev",
					// nextButton: ".swiper-button-next",
					//滑动之后回调函数
					on: {
						slideChangeTransitionStart: function() {
							var swiper = that.$refs.mySwiper_tab02.$swiper;
							console.log(swiper.activeIndex, 'swiper.activeIndex swiperIndexFirstSe')
							that.$emit('firSecondCateSlideTab', swiper.activeIndex)
						},
					},
				},
			}
		},
		 computed: {
		    // 定义swiper，在下面就可以引用这个swiper了；
		    swiper02: function () {
		      return this.$refs.mySwiper_tab02.$swiper
		    },
		  },
		  mounted() {
		  	this.swiper02.slideTo(localStorage.getItem('secondCategroy') || 0);
		  },
		watch: {
			swiperIndexFirstSe(value, oldvalue) {
				// 接收 nav组件传过来的导航按钮索引，跳转到相应的内容区
				this.swiper02.slideTo(value, 0, false)
			}
		},
	}
</script>

<style>
</style>
